(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ag-collection-layout"] && !Shopify.designMode) return;
  try {
    
function agCollectionInit(){
 const root=document.querySelector('[data-ag-collection]');if(!root||root.dataset.ready)return;root.dataset.ready='true';
 const cards=Array.from(root.querySelectorAll('.agc-card')),grid=root.querySelector('.agc-grid'),dialog=root.querySelector('dialog'),labels=JSON.parse(root.querySelector('[data-labels]').textContent);let category='all',style='all',size='',stock=false,max=Infinity;
 const seasonal=root.dataset.seasonal==='true';let query='';
 const normalize=value=>{value=value.toLowerCase();if(value.includes('adult'))return'adult';if(value.includes('button down'))return'button_down';if(value.includes('two piece'))return'two_piece';if(value.includes('comfy'))return'comfy';if(value.includes('romper'))return'romper';return''};
 cards.forEach((card,index)=>{card.agVariants=JSON.parse(card.querySelector('[data-variants]').textContent);card.agIndex=index;const image=card.querySelector('img');card.agImage=image?{src:image.getAttribute('src'),srcset:image.getAttribute('srcset')}:null;card.agPrice=card.querySelector('p').innerHTML;card.agUrl=card.querySelector('a').getAttribute('href');card.agStyle=v=>card.dataset.adult==='true'?'adult':Number(card.dataset.styleIndex)>=0?normalize(v.options[Number(card.dataset.styleIndex)]):normalize(card.dataset.title)});
 if(seasonal){
   cards.forEach(card=>{const original=card.agStyle;card.agStyle=v=>original(v)||card.dataset.type||'Other';});
   const group=root.querySelector('.agc-styles');group.querySelectorAll('[data-style]:not([data-style="all"])').forEach(b=>b.remove());
   const styleNames={romper:'Romper',two_piece:'Two Piece',button_down:'Button Down',comfy:'Comfy',adult:'Adult'};
   const garments=[...new Set(cards.flatMap(c=>c.agVariants.filter(v=>v.available).map(v=>c.agStyle(v))))];
   garments.forEach(value=>{const b=document.createElement('button');b.type='button';b.dataset.style=value;b.setAttribute('aria-pressed','false');b.textContent=styleNames[value]||value;group.append(b)});
 }
 const sizes=new Set();cards.forEach(c=>{if(Number(c.dataset.sizeIndex)>=0)c.agVariants.forEach(v=>sizes.add(v.options[Number(c.dataset.sizeIndex)]))});
 Array.from(sizes).sort((a,b)=>{const rank=v=>v==='NB'?-1:parseFloat(v)*(v.includes('Y')?12:1);return(rank(a)-rank(b))||a.localeCompare(b)}).forEach(s=>{const o=document.createElement('option');o.value=o.textContent=s;root.querySelector('[data-size]').append(o)});

 const allowed={all:['all','romper','two_piece','button_down','comfy','adult'],boys:['all','romper','two_piece','button_down'],girls:['all','romper','two_piece','comfy'],unisex:['all','romper','two_piece','button_down'],adult:['all','adult']};
 function variantMatches(card,variant){
   const audience=variant.audience||(card.dataset.adult==='true'?'adult':'');
   const garment=card.agStyle(variant);
   const categoryMatch=category==='all'||audience===category||(['boys','girls'].includes(category)&&audience==='unisex');
   const permittedStyle=seasonal||category==='all'||!garment||allowed[category].includes(garment);
   return (!seasonal||variant.available)&&categoryMatch&&permittedStyle&&(style==='all'||garment===style)&&(!size||variant.options[Number(card.dataset.sizeIndex)]===size)&&(!(stock||size)||variant.available)&&variant.price<=max;
 }
 function render(){
   let count=0;
   const filtered=category!=='all'||style!=='all'||!!size||stock||isFinite(max);
   cards.forEach(card=>{
     const text=(card.dataset.title+' '+card.dataset.type+' '+card.agVariants.map(v=>v.options.join(' ')).join(' ')).toLowerCase();
     const matching=query&&!text.includes(query)?[]:card.agVariants.filter(variant=>variantMatches(card,variant)).sort((a,b)=>a.price-b.price);
     card.hidden=!matching.length;
     if(!matching.length)return;
     count++;
     const selected=matching.find(variant=>variant.available)||matching[0];
     const productUrl=new URL(card.agUrl,location.origin);
     if(filtered)productUrl.searchParams.set('variant',selected.id);
     card.querySelectorAll('a').forEach(a=>a.href=filtered?productUrl.href:card.agUrl);
     if(filtered)card.querySelector('p').textContent=selected.money;else card.querySelector('p').innerHTML=card.agPrice;
     card.agSortPrice=filtered?selected.price:Number(card.dataset.price);
     const image=card.querySelector('img');
     if(image&&card.agImage){
       image.setAttribute('src',filtered&&selected.image?selected.image:card.agImage.src);
       if(filtered&&selected.image){const source=new URL(selected.image,location.origin);image.setAttribute('srcset',[240,360,540,720].map(width=>{source.searchParams.set('width',width);return source.href+' '+width+'w'}).join(','));}else if(card.agImage.srcset)image.setAttribute('srcset',card.agImage.srcset);
     }
   });
   root.querySelector('[data-count]').textContent=count+' '+labels.products;
   root.querySelector('[data-empty]').hidden=count>0;
   root.querySelector('[data-applied]').textContent=[size?labels.size+': '+size:'',stock?labels.stock:'',isFinite(max)?labels.max+': '+(max/100):''].filter(Boolean).join(' · ');
   const sort=root.querySelector('[data-sort]').value;
   [...cards].sort((a,b)=>{
     if(a.hidden!==b.hidden)return a.hidden?1:-1;
     if(a.hidden)return a.agIndex-b.agIndex;
     const difference=sort==='price-ascending'?a.agSortPrice-b.agSortPrice:sort==='price-descending'?b.agSortPrice-a.agSortPrice:sort==='created-descending'?Number(b.dataset.created)-Number(a.dataset.created):0;
     return difference||a.agIndex-b.agIndex;
   }).forEach(card=>grid.append(card));
 }
 root.querySelectorAll('[data-category]').forEach(button=>button.onclick=()=>{
   category=button.dataset.category;style='all';
   root.querySelectorAll('[data-category]').forEach(other=>other.setAttribute('aria-pressed',String(other===button)));
   root.querySelectorAll('[data-style]').forEach(other=>{other.hidden=seasonal?false:!allowed[category].includes(other.dataset.style);other.setAttribute('aria-pressed',String(other.dataset.style==='all'))});
   render();
 });
 root.querySelectorAll('[data-style]').forEach(b=>b.onclick=()=>{style=b.dataset.style;root.querySelectorAll('[data-style]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));render()});root.querySelector('[data-sort]').onchange=render;root.querySelector('[data-open-filter]').onclick=()=>dialog.showModal();root.querySelector('[data-apply]').onclick=()=>{size=root.querySelector('[data-size]').value;stock=root.querySelector('[data-stock]').checked;const value=root.querySelector('[data-max]').value;max=value===''?Infinity:Math.max(0,Number(value)*100);dialog.close();render()};root.querySelector('[data-clear]').onclick=()=>{size='';stock=false;max=Infinity;query='';if(seasonal){root.querySelector('[data-collection-search]').value='';root.querySelector('[data-category=all]').click()}root.querySelector('[data-size]').value='';root.querySelector('[data-stock]').checked=false;root.querySelector('[data-max]').value='';dialog.close();render()};
 const filterTrigger=root.querySelector('[data-open-filter]');
 let previousOverflow='';
 filterTrigger.onclick=()=>{previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';dialog.showModal()};
 dialog.addEventListener('close',()=>{document.body.style.overflow=previousOverflow;filterTrigger.focus({preventScroll:true})});
 if(seasonal){root.querySelector('[data-collection-search]').addEventListener('input',event=>{query=event.target.value.trim().toLowerCase();render()});render()}
 const initial=new URLSearchParams(location.search),initialCategory=initial.get('ag_category'),initialStyle=initial.get('ag_style');
 if(initialCategory&&Object.hasOwn(allowed,initialCategory))root.querySelector('[data-category="'+initialCategory+'"]').click();
 if(initialStyle&&allowed[category].includes(initialStyle))root.querySelector('[data-style="'+initialStyle+'"]').click();
}
document.addEventListener('DOMContentLoaded',agCollectionInit);document.addEventListener('shopify:section:load',agCollectionInit);agCollectionInit();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ag-collection-story"] && !Shopify.designMode) return;
  try {
    
function agRespectReducedMotion() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.ag-story__video').forEach(function(video) {
      video.autoplay = false;
      video.pause();
    });
  }
}
agRespectReducedMotion();
document.addEventListener('shopify:section:load', agRespectReducedMotion);
window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', agRespectReducedMotion);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ag-community"] && !Shopify.designMode) return;
  try {
    
function agLoadCommunity() {
  document.querySelectorAll('[data-ag-social-feed]').forEach(feed => {
    if (feed.dataset.ready) return;
    feed.dataset.ready = 'true';
    const load = () => {
      const script = document.createElement('script');
      script.src = 'https://foursixty.com/media/scripts/fs.slider.v2.5.js';
      script.async = true;
      script.dataset.feedId = 'atlas-grey';
      script.dataset.theme = 'slider_v2_5';
      script.dataset.openLinksInSamePage = 'true';
      script.dataset.showOkendoStars = 'true';
      script.dataset.cellSize = '25%';
      feed.append(script);
    };
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); load(); }
    }, {rootMargin:'600px'});
    observer.observe(feed);
  });
}
agLoadCommunity();
document.addEventListener('DOMContentLoaded', agLoadCommunity);
document.addEventListener('shopify:section:load', agLoadCommunity);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ag-help-faq"] && !Shopify.designMode) return;
  try {
    
function openLinkedAnswer() {
  const id = window.location.hash.slice(1);
  if (!id.startsWith('ag-help-')) return;
  const answer = document.getElementById(id);
  if (answer?.matches('.ag-help details')) {
    answer.open = true;
    answer.scrollIntoView({block: 'start'});
  }
}
openLinkedAnswer();
window.addEventListener('hashchange', openLinkedAnswer);
document.addEventListener('shopify:section:load', openLinkedAnswer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ag-product-layout"] && !Shopify.designMode) return;
  try {
    
function agInitializeProductLayout() {
  const root = document.querySelector('[data-section-type="product"]') || document.querySelector('.product-section');
  const scope = root || document;
  const buy = scope.querySelector('[data-add-to-cart]');
  const sticky = document.querySelector('.ag-pdp-sticky');
  const price = scope.querySelector('[data-product-price]');
  if (!buy || !sticky || sticky.dataset.ready) return;
  sticky.dataset.ready = 'true';
  const form = buy.closest('form');
  const style = scope.querySelector('.variant-wrapper[data-handle="style"]');
  const size = scope.querySelector('.variant-wrapper[data-handle="size"]');
  if (style && size && style.parentElement === size.parentElement) size.before(style);
  const variantsNode = scope.querySelector('[data-variant-json]');
  let variants = [];
  try { variants = JSON.parse(variantsNode ? variantsNode.value || variantsNode.textContent : '[]'); } catch (error) { variants = []; }
  if (style && size && variants.length) {
    const styleIndex = Number(style.querySelector('fieldset').dataset.index.replace('option', '')) - 1;
    const refreshStyles = () => {
      const selectedStyle = style.querySelector('input:checked');
      const sizeIndex = Number(size.querySelector('fieldset').dataset.index.replace('option','')) - 1;
      if (selectedStyle) size.querySelectorAll('input[type="radio"]').forEach(input => {
        const available = variants.some(variant => variant.available && variant.options[styleIndex] === selectedStyle.value && variant.options[sizeIndex] === input.value);
        input.disabled = !available;
        if (input.nextElementSibling) input.nextElementSibling.classList.toggle('disabled', !available);
      });
      style.querySelectorAll('input[type="radio"]').forEach(input => {
        const available = variants.some(variant => variant.available && variant.options[styleIndex] === input.value);
        input.disabled = !available;
        if (input.classList.contains('disabled') === available) input.classList.toggle('disabled', !available);
        const label = input.nextElementSibling;
        if (label && label.classList.contains('disabled') === available) label.classList.toggle('disabled', !available);
      });
    };
    style.addEventListener('click', event => {
      const label = event.target.closest('label[for]');
      const input = label ? document.getElementById(label.htmlFor) : event.target.closest('input[type="radio"]');
      if (!input || input.disabled) return;
      const chosen = Array.from(scope.querySelectorAll('.variant-wrapper input:checked'));
      const compatible = variants.filter(variant => variant.available && variant.options[styleIndex] === input.value);
      const variant = compatible.find(variant => chosen.every(item => item.name === input.name || variant.options[Number(item.dataset.index.replace('option', '')) - 1] === item.value)) || compatible[0];
      if (!variant) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      queueMicrotask(() => {
      scope.querySelectorAll('.variant-wrapper input[type="radio"]').forEach(item => {
        item.checked = variant.options[Number(item.dataset.index.replace('option', '')) - 1] === item.value;
      });
      input.dispatchEvent(new Event('change', {bubbles:true}));
      requestAnimationFrame(refreshStyles);
      });
    }, true);
    scope.addEventListener('change', () => requestAnimationFrame(refreshStyles));
    refreshStyles();
    window.addEventListener('load', refreshStyles, {once:true});
    new MutationObserver(refreshStyles).observe(style, {subtree:true,attributes:true,attributeFilter:['class']});
  }
  const quantity = scope.querySelector('.product__quantity');
  if (form && quantity) {
    const previous = quantity.parentElement;
    form.classList.add('ag-purchase-form');
    form.prepend(quantity);
    if (previous.classList.contains('product-block')) previous.hidden = true;
  }
  const sync = function() {
    const box = buy.getBoundingClientRect();
    sticky.hidden = box.bottom > 0;
    const output = sticky.querySelector('[data-ag-sticky-price]');
    if (price && output) output.textContent = price.textContent;
    const trigger = sticky.querySelector('button');
    trigger.textContent = buy.textContent.trim();
    trigger.disabled = buy.disabled;
    const selection = Array.from(scope.querySelectorAll('.variant-wrapper input:checked')).map(input => input.value).join(' · ');
    if (selection) sticky.querySelector('span').textContent = selection;
  };
  new IntersectionObserver(sync).observe(buy);
  new MutationObserver(sync).observe(buy, {attributes:true,childList:true,subtree:true});
  scope.addEventListener('change', () => requestAnimationFrame(sync));
  let scrollFrame = 0;
  window.addEventListener('scroll', () => {
    if (scrollFrame) return;
    scrollFrame = requestAnimationFrame(() => { scrollFrame = 0; sync(); });
  }, {passive:true});
  if (price) new MutationObserver(sync).observe(price, {childList:true,subtree:true,characterData:true});
  sticky.querySelector('button').addEventListener('click', function() {
    if (!buy.disabled) buy.click();
  });
  document.querySelectorAll('.ag-size-guide').forEach(function(link) {
    link.addEventListener('click', function() {
      const tab = Array.from(scope.querySelectorAll('.product-block--tab button')).find(function(button) {
        return /sizing chart|size chart/i.test(button.textContent);
      });
      if (!tab) return;
      if (tab.getAttribute('aria-expanded') !== 'true') tab.click();
      tab.scrollIntoView({behavior:'smooth',block:'center'});
      tab.focus({preventScroll:true});
    });
  });
  sync();
}
document.addEventListener('DOMContentLoaded', agInitializeProductLayout);
document.addEventListener('shopify:section:load', agInitializeProductLayout);
agInitializeProductLayout();

  } catch(e) { console.error(e); }
})();
})();
